import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { LocalStorageService, StorageItem } from '../services/local-storage.service';

import { API_URL } from '../constants/api-url.constants';
import { AuthService } from 'src/app/auth/services';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RxJsUtils } from '../utils';
import { environment } from 'src/environments/environment';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(
    private readonly authService: AuthService,
    private readonly localStorageService: LocalStorageService
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const isLoggedIn = this.authService.isLoggedIn;

    if (isLoggedIn) {
      let token = this.localStorageService.getItem(StorageItem.AuthToken);
      if (request.url.includes(API_URL.account.refreshAccessToken)) {
        token = this.localStorageService.getItem(StorageItem.RefreshToken); // in refresh token API, we need to send refresh token as part of header.
      }
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });

      if (request.url === `${API_URL.linkPreview.apiURL}/`) {
        request = request.clone({
          setHeaders: {
            'X-Linkpreview-Api-Key': API_URL.linkPreview.apiHeaderKey
          }
        });

        return next.handle(request);
      }
    }
    let url = request.url;

    if (url.startsWith('/')) {
      url = url.substr(1);
    }
    request = request.clone({
      url: `${environment.apiUrl}/${url}`
    });
    const { urlWithParams } = request;

    // Make it Dynamic later
    if (url === API_URL.projects.paginatedProjectList) {
      return next.handle(request);
    }

    return next.handle(request).pipe(RxJsUtils.shareDuplicate(urlWithParams));
  }
}
